import React from 'react';
import './index.scss';
import Tooltip from '../../../../common/tooltip/SimpleTooltip';
import { Translate } from 'react-redux-i18n';

class BarChartWrapper extends React.Component {
  render() {
    const {
      title = 'Chart Title',
      children,
      toolTip = 'tooltip content',
    } = this.props;
    return (
      <div className="fa-bar-chart-wrapper stock-chart">
        <div className="chart-title">
          {title}
          <Tooltip message={toolTip} position={'right'}>
            <i style={{ opacity: 0.5 }} className="icon-info fs-10 ml-2" />
          </Tooltip>
        </div>
        <div className="chart-content">{children}</div>
        <div className="chart-legend">
          {title === 'Z-SCORE' && (
            <>
              <div className="chart-legend__item">
                <div className="square square--green" />
                <div className="title">
                  <Translate
                    value={`financialAnalysis.footerNoteZBarChart.safe`}
                  />
                </div>
              </div>
              <div className="chart-legend__item">
                <div className="square square--yellow" />
                <div className="title">
                  <Translate
                    value={`financialAnalysis.footerNoteZBarChart.nomal`}
                  />
                </div>
              </div>
              <div className="chart-legend__item">
                <div className="square square--red" />
                <div className="title">
                  <Translate
                    value={`financialAnalysis.footerNoteZBarChart.distress`}
                  />
                </div>
              </div>
            </>
          )}

          {title === 'M-SCORE' && (
            <>
              <div className="chart-legend__item">
                <div className="square square--green" />
                <div className="title">
                  <Translate
                    value={`financialAnalysis.footerNoteMBarChart.notManipulator`}
                  />
                </div>
              </div>
              <div className="chart-legend__item">
                <div className="square square--red" />
                <div className="title">
                  <Translate
                    value={`financialAnalysis.footerNoteMBarChart.manipulator`}
                  />
                </div>
              </div>
            </>
          )}

          {title === 'F-SCORE' && (
            <>
              <div className="chart-legend__item">
                <div className="square square--green" />
                <div className="title">
                  <Translate
                    value={`financialAnalysis.footerNoteFBarChart.good`}
                  />
                </div>
              </div>
              <div className="chart-legend__item">
                <div className="square square--yellow" />
                <div className="title">
                  <Translate
                    value={`financialAnalysis.footerNoteFBarChart.normal`}
                  />
                </div>
              </div>
              <div className="chart-legend__item">
                <div className="square square--red" />
                <div className="title">
                  <Translate
                    value={`financialAnalysis.footerNoteFBarChart.weak`}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default BarChartWrapper;
